import type { AnalyticsEventPayload } from '@atlaskit/analytics-next/AnalyticsEvent';
import createAndFireEvent from '@atlaskit/analytics-next/createAndFireEvents';
import type { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next/types';
import { TRACK_EVENT_TYPE } from '@atlassian/analytics-bridge/constants';

import { UI_MODIFICATIONS_ANALYTICS_CHANNEL } from '../constants';

export const fireTrackEvent = (
	createAnalyticsEvent: CreateUIAnalyticsEvent,
	eventPayload: AnalyticsEventPayload,
): void => {
	createAndFireEvent(UI_MODIFICATIONS_ANALYTICS_CHANNEL)({
		...eventPayload,
		analyticsType: TRACK_EVENT_TYPE,
	})(createAnalyticsEvent);
};
